import { render, staticRenderFns } from "./coursePersonnel.vue?vue&type=template&id=70e50198&scoped=true"
import script from "./coursePersonnel.vue?vue&type=script&lang=js"
export * from "./coursePersonnel.vue?vue&type=script&lang=js"
import style0 from "./coursePersonnel.vue?vue&type=style&index=0&id=70e50198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e50198",
  null
  
)

export default component.exports